// frontend/src/pages/ResetPassword.jsx  — NEW FILE
// Supabase sends users here after they click the reset-password email link.
// The URL contains #access_token=... — supabase.auth.onAuthStateChange will catch it
// and emit a PASSWORD_RECOVERY event. We then let the user set a new password.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/auth/AuthContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Supabase parses the hash and emits PASSWORD_RECOVERY
    const { data: listener } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") setReady(true);
    });
    return () => listener.subscription.unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Le password non coincidono.");
      return;
    }
    if (password.length < 8) {
      toast.error("La password deve essere di almeno 8 caratteri.");
      return;
    }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      toast.error(error.message);
    } else {
      toast.success("Password aggiornata! Accesso in corso...");
      setTimeout(() => navigate("/dashboard", { replace: true }), 1500);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-5">
      <div className="w-full max-w-md border border-neutral-200 rounded-[14px] p-8 md:p-12 bg-white">
        <a href="/" className="flex items-center gap-2 select-none">
          <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: "#c9a86a" }} />
          <span className="font-display tracking-[0.28em] text-[13px] font-medium text-neutral-950">
            WEDFLOW
          </span>
        </a>
        <h1 className="mt-10 font-display text-[34px] font-light text-neutral-950 tracking-[-0.02em]">
          Nuova password.
        </h1>

        {!ready ? (
          <p className="mt-6 text-[14px] text-neutral-500">
            Verifica del link in corso…
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <div>
              <label className="block text-[13px] text-neutral-600 mb-1.5">Nuova password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                placeholder="Minimo 8 caratteri"
                className="w-full px-4 py-3 rounded-xl border border-neutral-200 text-[14px] bg-white focus:outline-none focus:ring-2 focus:ring-[#c9a86a]/40 focus:border-[#c9a86a] transition"
              />
            </div>
            <div>
              <label className="block text-[13px] text-neutral-600 mb-1.5">Conferma password</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                placeholder="Ripeti la password"
                className="w-full px-4 py-3 rounded-xl border border-neutral-200 text-[14px] bg-white focus:outline-none focus:ring-2 focus:ring-[#c9a86a]/40 focus:border-[#c9a86a] transition"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              className="w-full py-3.5 rounded-full text-[14px] font-medium text-white disabled:opacity-50"
              style={{ background: "#c9a86a" }}
            >
              {busy ? "Aggiornamento…" : "Aggiorna password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
